import { initialApiState } from "../common";

const initialState = {
  userData: initialApiState,
  isUserLoggedIn: false,
};

export default initialState;
